module.exports = __webpack_public_path__ + "static/img/5.8c61593.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/5.png
// module id = 4de1
// module chunks = 0